import QuestionAlerts from './QuestionAlerts';

export default QuestionAlerts;
